// blakfy-cookie/src/i18n/translations/it.js — Italian translations

export default {
  title: "Preferenze Cookie",
  intro:
    "Questo sito usa i cookie per migliorare la tua esperienza. Consulta la nostra Informativa sui Cookie.",
  policyLink: "Informativa sui Cookie",
  acceptAll: "Accetta tutti",
  rejectAll: "Rifiuta tutti",
  preferences: "Preferenze",
  save: "Salva scelte",
  close: "Chiudi",
  cat: {
    essential: {
      title: "Cookie essenziali",
      desc: "Necessari per il funzionamento del sito. Non disattivabili.",
      always: "Sempre attivo",
    },
    analytics: {
      title: "Cookie analitici",
      desc: "Usati per raccogliere statistiche di visita anonime.",
    },
    marketing: {
      title: "Cookie di marketing",
      desc: "Usati per pubblicità personalizzata e retargeting.",
    },
    functional: {
      title: "Cookie funzionali",
      desc: "Usati per ricordare preferenze come lingua e tema.",
    },
  },
  placeholder: {
    title: "Contenuto bloccato",
    desc: "Devi consentire i cookie {category} per visualizzare questo contenuto.",
    cta: "Consenti",
  },
  tabs: {
    categories: "Categories",
    services: "Services",
    about: "About",
  },
  service: {
    description: "Description",
    processor: "Data Processor",
    address: "Address",
    dpo: "DPO Contact",
    purposes: "Purposes",
    technologies: "Technologies Used",
    dataCollected: "Data Collected",
    legalBasis: "Legal Basis",
    retention: "Retention Period",
    transferCountries: "Transfer Countries",
    privacyPolicy: "Privacy Policy",
    cookiePolicy: "Cookie Policy",
    legalBasisValues: {
      consent: "Consent (Art. 6 para. 1 s. 1 lit. a GDPR)",
      legitimate_interest: "Legitimate Interest (Art. 6 para. 1 s. 1 lit. f GDPR)",
    },
    noServices: "No services are configured for this site.",
  },
  svcAbout: {
    title: "About this CMP",
    description:
      "This website uses Blakfy Cookie Management Platform (CMP) to manage your consent preferences in compliance with GDPR, KVKK, CCPA and other applicable privacy regulations.",
    version: "Version",
    learnMore: "Learn more at blakfy.com",
  },
};
